<template>
  <div>
    <app-header></app-header>
    <section class="home-banner inner-banner">
      <div class="container-lg position-relative">
        <h2 class="font-bold page-title text-center">Organic Products</h2>

        <img src="/assets/custom/img/bottle-n-leaf.png" width="440" height="339" class="bnr-organic-left" />
        <img src="/assets/custom/img/sunflower-organic.png" width="440" height="339" class="bnr-organic-right" />
      </div>

      <div class="wall"></div>
      <img src="/assets/custom/img/assets.png" width="440" height="339" class="assets" />
    </section>

    <section class="category-description">
      <div class="container-lg">
        <div class="box">
          <img :src="'/img/category/' + productDetails.img" width="633" height="646" class="product-img" />
          <div class="display-3 font-bold text-green">{{ productDetails.name }}</div>
          <div class="h3 text-green pb-4">{{ productDetails.sub_header }}</div>
          <div v-html="productDetails.description"></div>
        </div>
      </div>
    </section>
    <section class="product-liting py-4 py-md-5">
      <div class="container">
        <div class="d-flex product-listing row">
          <li v-for="(item, index) in categoryProducts" :key="'product-listing-' + index" class="col-xs-12 col-sm-12 col-md-4">
            <router-link tag="a" :to="'/product/' + item.slug">
              <div class="item">
                <div class="border"></div>
                <div class="textHV text-white">
                  <img src="/assets/custom/img/icon-leaf.png" data-src="/assets/custom/img/icon-leaf.png" alt="leaf"
                    class="pb-4 w-100" width="30" />
                  <h3 class="font-bold">{{ item.name }}</h3>
                  <div class="description" v-html="item.short_description"></div>
                </div>
                <div class="text text-white">
                  <img src="/assets/custom/img/icon-leaf.png" data-src="/assets/custom/img/icon-leaf.png" alt="leaf"
                    class="pb-4 w-100" width="30" />
                </div>
                <img class="w-100" :src="'/img/product/' + item.img" :data-src="'/img/product/' + item.img"
                  :alt="item.name.toLowerCase()" width="617" height="521" />
              </div>
            </router-link>
          </li>
        </div>
        <div class=" rounded my-4 mb-5 p-md-5 p-4 text-center">
          <h3 class="font-bold pb-3"> Click here for updated product list</h3> <a href="javascript:void(0)" data-toggle="modal"
            data-target="#exampleModal" class="btn btn-green">Download Brochure</a>
        </div>
      </div>
    </section>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Header from './header.vue'
import Footer from './footer.vue'
export default {
  data() {
    return {
      productDetails: {},
      categoryProducts: [],
      slug: ''
    };
  },
  mounted() {
    this.slug = this.$route.params.slug;
    this.getProductDetails();
    this.getProducts();
  },
  components: {
    "app-header": Header,
    "app-footer": Footer
  },
  methods: {
    getProductDetails() {
      axios.get(`/api/category/details/${this.slug}`)
        .then(response => {
          let productDetails = response.data;
          if (productDetails[0]) {
            this.productDetails = productDetails[0];
          }
        }).catch(error => {
          console.error(error);
        });
    },
    getProducts() {
      axios.get(`/api/product/category/${this.slug}`)
        .then(response => {
          this.categoryProducts = response.data;
        }).catch(error => {
          console.error(error);
        });
    }
  }
}
</script>




